<div class="mainWrap">
    <div class="bgImageWrap">
        <img src="../../../../assets/images/techBg.png">
    </div>
    <div class="bgMobileImageWrap">
        <img src="../../../../assets/images/TechnologiesMobile.png">
    </div>

    <div class="overLay">
        <div class="textWrap">
            <div class="titleWrap">
                Technologies
            </div>
            <div class="subDescWrap">
                We use cutting edge technologies to tackle modern complex problems.
            </div>
            <div class="subTitleWrap">
                We take a deep dive into various digital advances and leverage these technologies to build winning products. We work on breakthrough technologies and deliver mission critical mobile and web applications. To name a few technologies that we have mastered, include Java, Angular.js, Node.js, and React.
            </div>
            <div class="knowMoreWrap">
                <div class="buttonWrap">
                    <button [routerLink]="['/technology']" >
                        View All Technologies
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>